import { CalculatedFieldInput } from "../../Common/ExpressionBuilder/CalculatedFieldInput";

export const ExpressionProperty = {
  propertyName: "Expression",
  propertyDisplay: "Expression",
  propertyType: "string",
  propertyCategory: "Data",
  renderer: function ({
    handlePropertyChange,
    currentPropertyValues,
    galleryFields,
    isGalleryEditor,
  }) {
    return (
      <CalculatedFieldInput
        handlePropertyChange={handlePropertyChange}
        defaultValue={currentPropertyValues?.[this.propertyName] || ""}
        galleryFields={galleryFields}
        isGalleryEditor={isGalleryEditor}
      />
    );
  },
};
